import { action } from '../../lib/actionHelpers.js';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import getMessageIcon from '../../lib/getMessageIcon.js';
import selectors from '../../selectors/selectors.js';
import SVG from '../../images/svg/SVG.js';

const SearchFilterItem = ({ item }) => {
  const filterValue = useSelector((state) => state.ui.filters[item.id || item.type]);
  const isMobile = useSelector(selectors.mobile);

  const searchInput = useRef(null);
  const [searchFocused, setSearchFocused] = useState(false);

  useEffect(() => {
    if (!filterValue && document.activeElement !== searchInput.current) {
      setSearchFocused(false);
    }
  }, [filterValue]);

  const handleSearchIconClick = () => {
    setSearchFocused(true);
    setTimeout(() => {
      if (searchInput.current) {
        searchInput.current.focus();
      }
    }, 100);
  };

  const handleSearchFocus = () => {
    setSearchFocused(true);
  };

  const handleSearchBlur = () => {
    if (!filterValue) {
      setSearchFocused(false);
    }
  };

  const handleSearchCloseClick = () => {
    if (searchInput.current) {
      searchInput.current.blur();
    }
    setSearchFocused(false);
    action('uiPatchFilters', {
      [item.id || item.type]: '',
    });
  };

  return (
    <form
      autoComplete={'off'}
      onSubmit={(e) => {
        e.preventDefault();
        return false;
      }}
    >
      <div className={`filter-item search ${searchFocused || filterValue || isMobile ? 'active ' : ''}`}>
        <SVG className={'search-icon'} basic={true} icon={'Search'} onClick={handleSearchIconClick} />
        <input type="text" className="search-input" autoComplete={'off'} placeholder={'Search'} ref={searchInput} value={filterValue || ''} onChange={(e) => action('uiSetSearch', e.target.value)} onFocus={handleSearchFocus} onBlur={handleSearchBlur} />
        {(!isMobile || filterValue) && <img className={`filter-item-close-btn`} src={getMessageIcon('icon-close')} alt={''} onClick={handleSearchCloseClick} />}
      </div>
    </form>
  );
};

export default SearchFilterItem;
